import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { CallsDetailsReportFilterForm } from 'src/app/shared/interfaces';
import { Constants } from '../../common';
import { Mapper } from '../mapper/mapper';
import { CallsDetailsReport } from '../model/calls-details-model';
import { BaseAPI } from './base-api';
import { DataWithPagination } from '../../interface';

@Injectable({
  providedIn: 'root',
})
export class CallsDetailsReportApi {
  constructor(private baseAPI: BaseAPI, private mapper: Mapper) {}

  getCallsDetailsReport(filter: CallsDetailsReportFilterForm): Observable<DataWithPagination<CallsDetailsReport>> {
    return this.baseAPI.post(Constants.GET_CALLS_DETAILS_REPORT_API_URL, filter).pipe(
      map((res) => {
        const data: DataWithPagination<CallsDetailsReport> = {
          data: this.mapper.fromJson(CallsDetailsReport, res.item),
          count: res.count
        }
        return data;
      })
    );
  }
}
